module.exports = __webpack_public_path__ + "img/green_144.912c7e86.png";